const civilwars = [
    {
        name: 'Argentine Civil Wars',
        started: 1814,
        ended: 1880,
        casualties: null,
        locations: ['Argentina', 'Uruguay'],
        description: 'The Argentine Civil Wars were a series of internecine wars that took place in Argentina from 1814 to 1880. These conflicts were separate from the Argentine War of Independence (1810–1820), though they first arose during this period.',
        wiki: 'https://en.wikipedia.org/wiki/Argentine_Civil_Wars',
    }, {
        name: 'Ndwandwe-Zulu War',
        started: 1817,
        ended: 1819,
        casualties: null,
        locations: ['South Africa'],
        description: 'The Zulu Civil War or Ndwandwe–Zulu War of 1817–1819 was a war fought between the expanding Zulu Kingdom and the Ndwandwe tribe in South Africa.',
        wiki: 'https://en.wikipedia.org/wiki/Zulu_Civil_War',
    }, {
        name: 'Greek Civil Wars',
        started: 1824,
        ended: 1825,
        casualties: null,
        locations: ['Greece'],
        description: 'The Greek War of Independence was marked by two civil wars, which took place in 1824–1825. The conflict had both political and regional dimensions, as it pitted the Roumeliotes (the people of Continental Greece) and the Islanders (the shipowners, especially from Hydra island), against the Peloponnesians or Moreotes.',
        wiki: 'https://en.wikipedia.org/wiki/Greek_civil_wars_of_1824%E2%80%931825',
    }, {
        name: 'Liberal Wars',
        started: 1828,
        ended: 1834,
        casualties: null,
        locations: ['Portugal'],
        description: 'The Liberal Wars, also known as the Portuguese Civil War, the War of the Two Brothers or Miguelite War, was a war between progressive constitutionalists and authoritarian absolutists in Portugal over royal succession that lasted from 1828 to 1834.',
        wiki: 'https://en.wikipedia.org/wiki/Liberal_Wars',
    }, {
        name: 'Chilean Civil War',
        started: 1829,
        ended: 1830,
        casualties: null,
        locations: ['Chile'],
        description: 'The Chilean Civil War of 1829–1830 (Spanish: Guerra Civil de 1829-1830) was an armed conflict between conservative Pelucones and liberal Pipiolos forces in Chile over the constitutional regime in force.',
        wiki: 'https://en.wikipedia.org/wiki/Chilean_Civil_War_of_1829%E2%80%9330',
    }, {
        name: 'Ragamuffin War',
        started: 1835,
        ended: 1845,
        casualties: 20000,
        locations: ['Brazil'],
        description: 'The Ragamuffin War (Portuguese: Guerra dos Farrapos or, more commonly Revolução Farroupilha) was a Republican uprising that began in southern Brazil, in the state of Rio Grande do Sul in 1835.',
        wiki: 'https://en.wikipedia.org/wiki/Ragamuffin_War',
    }, {
        name: 'Carlist Wars',
        started: 1833,
        ended: 1876,
        casualties: null,
        locations: ['Spain'],
        description: 'The Carlist Wars were a series of civil wars that took place in Spain during the 19th century. The contenders fought to establish their claim to the throne, although some political differences also existed.',
        wiki: 'https://en.wikipedia.org/wiki/Carlist_Wars',
    }, {
        name: 'Uruguayan Civil War',
        started: 1839,
        ended: 1851,
        casualties: null,
        locations: ['Uruguay'],
        description: 'The Uruguayan Civil War, also known in Spanish as the Guerra Grande ("Great War"), was a series of armed conflicts between the leaders of Uruguayan independence.',
        wiki: 'https://en.wikipedia.org/wiki/Uruguayan_Civil_War',
    }, {
        name: 'New Zealand Wars',
        started: 1845,
        ended: 1872,
        casualties: 2899 ,
        locations: ['New Zealand'],
        description: 'The New Zealand Wars were a series of armed conflicts that took place in New Zealand from 1845 to 1872 between the New Zealand government and the Māori.',
        wiki: 'https://en.wikipedia.org/wiki/New_Zealand_Wars',
    }, {
        name: 'Sonderbund War',
        started: 1847,
        ended: 1847,
        casualties: 86,
        locations: ['Switzerland'],
        description: 'The Sonderbund War (German: Sonderbundskrieg) of November 1847 was a civil war in Switzerland, then still a relatively loose confederacy of cantons (states). It ensued after seven Catholic cantons formed the Sonderbund ("separate alliance") in 1845 to protect their interests against a centralization of power.',
        wiki: 'https://en.wikipedia.org/wiki/Sonderbund_War',
    }, {
        name: 'Revolutions of 1848',
        started: 1848,
        ended: 1849,
        casualties: null,
        locations: ['France, Germany, Austria, Hungary, Italy, Denmark, Poland, Romania, Sweden, Switzerland, Belgium, Ireland'],
        description: "The Revolutions of 1848, known in some countries as the Spring of Nations, People's Spring, Springtime of the Peoples, or the Year of Revolution, were a series of political upheavals throughout Europe in 1848. It remains the most widespread revolutionary wave in European history.",
        wiki: 'https://en.wikipedia.org/wiki/Revolutions_of_1848',
    }, {
        name: '1851 Chilean Revolution',
        started: 1851,
        ended: 1851,
        casualties: null,
        locations: ['Chile'],
        description: 'The Revolution of 1851 (or Civil War of 1851) was an attempt by Chilean liberals to overthrow the conservative government of president Manuel Montt and repeal the Chilean Constitution of 1833. After various battles and sieges, by late December 1851 government forces had subdued the revolutionaries.',
        wiki: 'https://en.wikipedia.org/wiki/1851_Chilean_Revolution',
    }, {
        name: 'Taiping Rebellion',
        started: 1850,
        ended: 1871,
        casualties: 30000000,
        locations: ['China'],
        description: 'The Taiping Rebellion or the Taiping Civil War was a massive rebellion or civil war in China that lasted from 1850 to 1864 and was fought between the established Manchu-led Qing dynasty and the Christian millenarian movement of the Heavenly Kingdom of Peace.',
        wiki: 'https://en.wikipedia.org/wiki/Taiping_Rebellion',
    }, {
        name: 'Bleeding Kansas',
        started: 1851,
        ended: 1861,
        casualties: 70,
        locations: ['United States'],
        description: 'Bleeding Kansas, Bloody Kansas or the Border War was a series of violent political confrontations in the United States between 1854 and 1861 involving anti-slavery "Free-Staters" and pro-slavery "Border Ruffian", or "southern" elements in Kansas.',
        wiki: 'https://en.wikipedia.org/wiki/Bleeding_Kansas',
    }, {
        name: 'Reform War',
        started: 1857,
        ended: 1861,
        casualties: null,
        locations: ['Mexico'],
        description: 'The War of the Reform (Spanish: Guerra de Reforma) in Mexico, during the Second Federal Republic of Mexico, was the three-year civil war (1857 - 1860) between liberals who had taken power in 1855 under the Plan of Ayutla, and conservatives resisting the legitimacy of the government and its radical restructuring of Mexican laws, known as La Reforma.',
        wiki: 'https://en.wikipedia.org/wiki/Reform_War',
    }, {
        name: 'American Civil War',
        started: 1861,
        ended: 1865,
        casualties: 1000000,
        locations: ['United States'],
        description: 'The American Civil War was fought in the United States from 1861 to 1865. The result of a long-standing controversy over slavery, war broke out in April 1861, when Confederates attacked Fort Sumter in South Carolina, shortly after President Abraham Lincoln was inaugurated.',
        wiki: 'https://en.wikipedia.org/wiki/American_Civil_War',
    }, {
        name: 'Klang War',
        started: 1867,
        ended: 1874,
        casualties: null,
        locations: ['Malaysia'],
        description: 'The Klang War or Selangor Civil War was a series of conflicts that lasted from 1867 to 1874 in the Malay state of Selangor.',
        wiki: 'https://en.wikipedia.org/wiki/Klang_War',
    }, {
        name: 'Boshin War',
        started: 1868,
        ended: 1869,
        casualties: 8200,
        locations: ['Japan'],
        description: 'The Boshin War (Boshin Sensō, "War of the Year of the Yang Earth Dragon"), sometimes known as the Japanese Revolution, was a civil war in Japan, fought from 1868 to 1869 between forces of the ruling Tokugawa shogunate and those seeking to return political power to the Imperial Court.',
        wiki: 'https://en.wikipedia.org/wiki/Boshin_War',
    }, {
        name: 'Satsuma Rebellion',
        started: 1877,
        ended: 1877,
        casualties: 16278,
        locations: ['Japan'],
        description: 'The Satsuma Rebellion (Seinan Sensō, "Southwestern War") was a revolt of disaffected samurai against the new imperial government, nine years into the Meiji Era.',
        wiki: 'https://en.wikipedia.org/wiki/Satsuma_Rebellion',
    }, {
        name: 'Jementah Civil War',
        started: 1879,
        ended: 1879,
        casualties: null,
        locations: ['Malaysia'],
        description: 'The War of the Reform (Spanish: Guerra de Reforma) in Mexico, during the Second Federal Republic of Mexico, was the three-year civil war (1857 - 1860) between liberals who had taken power in 1855 under the Plan of Ayutla, and conservatives resisting the legitimacy of the government and its radical restructuring of Mexican laws, known as La Reforma.',
        wiki: 'https://en.wikipedia.org/wiki/Jementah_Civil_War',
    }, {
        name: 'North-West Rebellion',
        started: 1885,
        ended: 1885,
        casualties: 88,
        locations: ['Canada'],
        description: 'The North-West Rebellion (or the North-West Resistance, Saskatchewan Rebellion, Northwest Uprising, or Second Riel Rebellion) of 1885 was a brief and unsuccessful uprising by the Métis people under Louis Riel and an associated uprising by First Nations Cree and Assiniboine of the District of Saskatchewan against the government of Canada.',
        wiki: 'https://en.wikipedia.org/wiki/North-West_Rebellion',
    }, {
        name: 'Chilean Civil War of 1891',
        started: 1891,
        ended: 1891,
        casualties: 5000,
        locations: ['Chile'],
        description: 'The Chilean Civil War of 1891, also known as Revolution of 1891 was an armed conflict between forces supporting Congress and forces supporting the President, José Manuel Balmaceda.',
        wiki: 'https://en.wikipedia.org/wiki/Chilean_Civil_War_of_1891',
    }, {
        name: 'War of Canudos',
        started: 1896,
        ended: 1897,
        casualties: 30000,
        locations: ['Brazil'],
        description: 'The War of Canudos (Guerra de Canudos) was a conflict between the state of Brazil and a group of some 30,000 settlers who had founded their own community in the Northeastern state of Bahia, named Canudos.',
        wiki: 'https://en.wikipedia.org/wiki/War_of_Canudos',
    }, {
        name: 'Banana Wars',
        started: 1898,
        ended: 1934,
        casualties: null,
        locations: ['Panama', 'Cuba', 'Dominican Republic', 'Nicaragua', 'Mexico', 'Haiti', 'Honduras'],
        description: 'The Banana Wars were the occupations, police actions, and interventions on the part of the United States in Central America and the Caribbean between the end of the Spanish–American War in 1898 and the inception of the Good Neighbor Policy in 1934.',
        wiki: 'https://en.wikipedia.org/wiki/Banana_Wars',
    }, {
        name: 'Boxer Rebellion',
        started: 1899,
        ended: 1901,
        casualties: 36700,
        locations: ['China'],
        description: 'The Boxer Rebellion, Boxer Uprising or Yihetuan Movement was a violent anti-foreign, anti-colonial, and anti-Christian uprising that took place in China between 1899 and 1901, toward the end of the Qing dynasty.',
        wiki: 'https://en.wikipedia.org/wiki/Boxer_Rebellion',
    }, {
        name: "Thousand Days' War",
        started: 1899,
        ended: 1902,
        casualties: 120000,
        locations: ['Colombia'],
        description: "The Thousand Days' War (1899–1902) (Spanish: Guerra de los Mil Días), was a civil armed conflict in the Republic of Colombia (including its then Department of Panama), between the Conservative Party, the Liberal Party and radical factions.",
        wiki: 'https://en.wikipedia.org/wiki/Thousand_Days%27_War',
    }, {
        name: 'Mexican Revolution',
        started: 1910,
        ended: 1920,
        casualties: 2000502,
        locations: ['Mexico'],
        description: 'The Mexican Revolution (Spanish: Revolución mexicana) was a major armed struggle c. 1910–1920 radically transforming Mexican culture and government.',
        wiki: 'https://en.wikipedia.org/wiki/Mexican_Revolution',
    }, {
        name: 'Warlord Era',
        started: 1916,
        ended: 1928,
        casualties: null,
        locations: ['China'],
        description: 'The Warlord Era was a period in the history of the Republic of China when the control of the country was divided among former military cliques of the Beiyang Army and other regional factions.',
        wiki: 'https://en.wikipedia.org/wiki/Warlord_Era',
    }, {
        name: 'Russian Civil War',
        started: 1917,
        ended: 1923,
        casualties: 9000000,
        locations: ['Russia'],
        description: "Russian Civil War (November 1917 – October 1922) was a multi-party war in the former Russian Empire immediately after the Russian Revolutions of 1917, as many factions vied to determine Russia's political future.",
        wiki: 'https://en.wikipedia.org/wiki/Russian_Civil_War',
    }, {
        name: 'Iraqi–Kurdish conflict',
        started: 1918,
        ended: 2003,
        casualties: 345100,
        locations: ['Iraq'],
        description: 'The Iraqi–Kurdish conflict consists of a series of wars and rebellions by the Kurds against the central authority of Iraq during the 20th century, which began shortly after the defeat of the Ottoman Empire in World War I and lasting until the U.S. invasion of Iraq in 2003.',
        wiki: 'https://en.wikipedia.org/wiki/Iraqi%E2%80%93Kurdish_conflict',
    }, {
        name: 'Finnish Civil War',
        started: 1918,
        ended: 1918,
        casualties: 38300,
        locations: ['Finland'],
        description: 'The Finnish Civil War (27 January – 15 May 1918) concerned leadership and control of Finland during the transition from a Grand Duchy of the Russian Empire to an independent state.',
        wiki: 'https://en.wikipedia.org/wiki/Finnish_Civil_War',
    }, {
        name: 'German Revolution of 1918–19',
        started: 1918,
        ended: 1919,
        casualties: null,
        locations: ['Germany'],
        description: 'The German Revolution or November Revolution (German: Novemberrevolution) was a civil conflict in the German Empire at the end of the First World War that resulted in the replacement of the German federal constitutional monarchy with a democratic parliamentary republic that later became known as the Weimar Republic.',
        wiki: 'https://en.wikipedia.org/wiki/German_Revolution_of_1918%E2%80%9319',
    }, {
        name: 'Irish Civil War',
        started: 1922,
        ended: 1923,
        casualties: 4050,
        locations: ['Ireland'],
        description: 'The Irish Civil War (Irish: Cogadh Cathartha na hÉireann; 28 June 1922 – 24 May 1923) was a conflict that followed the Irish War of Independence and accompanied the establishment of the Irish Free State, an entity independent from the United Kingdom but within the British Empire.',
        wiki: 'https://en.wikipedia.org/wiki/Irish_Civil_War',
    }, {
        name: 'Paraguayan Civil War',
        started: 1922,
        ended: 1923,
        casualties: null,
        locations: ['Paraguay'],
        description: 'The Paraguayan Civil War (1922), took place between 27 May 1922 and 10 July 1923, within the borders of Paraguay. It started when supporters of candidate Adolfo Chirife attempted to forcefully restore the implementation of presidential elections canceled by President Eusebio Ayala.',
        wiki: 'https://en.wikipedia.org/wiki/Paraguayan_Civil_War_(1922)',
    }, {
        name: 'Nicaraguan Civil War',
        started: 1926,
        ended: 1927,
        casualties: null,
        locations: ['Nicaragua'],
        description: "The Nicaraguan civil war of 1926–1927, or the Constitutionalist War, broke out after a coup d'état by Emiliano Chamorro, a member of the Conservative Party, removed Nicaragua's democratically elected government, resulting in a rebellion by members of the Liberal Party.",
        wiki: 'https://en.wikipedia.org/wiki/Nicaraguan_civil_war_(1926%E2%80%9327)',
    }, {
        name: 'Cristero War',
        started: 1926,
        ended: 1929,
        casualties: 250000,
        locations: ['Mexico'],
        description: 'The Cristero War or Cristero Rebellion (1926–29), also known as La Cristiada [la kɾistˈjaða], was a widespread struggle in many central-western Mexican states against the secularist, anti-Catholic and anti-clerical policies of the Mexican government.',
        wiki: 'https://en.wikipedia.org/wiki/Cristero_War',
    }, {
        name: 'Chinese Civil War',
        started: 1927,
        ended: 1950,
        casualties: 17500000,
        locations: ['China'],
        description: 'The Chinese Civil War was a war fought between the Kuomintang (KMT)-led government of the Republic of China and the Communist Party of China (CPC).',
        wiki: 'https://en.wikipedia.org/wiki/Chinese_Civil_War',
    }, {
        name: 'Constitutionalist Revolution',
        started: 1932,
        ended: 1932,
        casualties: 3550,
        locations: ['Brazil'],
        description: "The Constitutionalist Revolution of 1932 (sometimes also referred to as Paulista War or Brazilian Civil War) is the name given to the uprising of the population of the Brazilian state of São Paulo against the 1930 coup d'état when Getúlio Vargas forcibly assumed the nation's Presidency",
        wiki: 'https://en.wikipedia.org/wiki/Constitutionalist_Revolution',
    }, {
        name: 'Austrian Civil War',
        started: 1934,
        ended: 1934,
        casualties: 1118,
        locations: ['Austria'],
        description: 'The Austrian Civil War (German: Österreichischer Bürgerkrieg), also known as the February Uprising (German: Februarkämpfe), is a term sometimes used for a few days of skirmishes between socialist and conservative-fascist forces between 12 February and 16 February 1934, in Austria.',
        wiki: 'https://en.wikipedia.org/wiki/Austrian_Civil_War',
    }, {
        name: 'Spanish Civil War',
        started: 1936,
        ended: 1939,
        casualties: 795000,
        locations: ['Spain'],
        description: 'The Republicans, who were loyal to the democratic, left-leaning and relatively urban Second Spanish Republic, in an alliance of convenience with the Anarchists, fought against the Nationalists, a Falangist, Carlist, and largely aristocratic conservative group led by General Francisco Franco.',
        wiki: 'https://en.wikipedia.org/wiki/Spanish_Civil_War',
    }, {
        name: 'Forest Brothers',
        started: 1940,
        ended: 1956,
        casualties: null,
        locations: ['Estonia', 'Latvia', 'Lithuania'],
        description: 'The Forest Brothers (also Brothers of the Forest, Forest Brethren, or Forest Brotherhood; Estonian: metsavennad, Latvian: meža brāļi, Lithuanian: miško broliai) were Estonian, Latvian, and Lithuanian partisans who waged a guerrilla war against Soviet rule during the Soviet invasion and occupation of the three Baltic states during, and after, World War II.',
        wiki: 'https://en.wikipedia.org/wiki/Forest_Brothers',
    }, {
        name: 'Ukrainian Insurgent Army',
        started: 1942,
        ended: 1956,
        casualties: null,
        locations: ['Ukraine'],
        description: 'The Ukrainian Insurgent Army (Ukrainian: Українська повстанська армія, УПА, Ukrayins’ka Povstans’ka Armiya, UPA) was a Ukrainian nationalist paramilitary and later partisan army that engaged in a series of guerrilla conflicts during World War II against Nazi Germany, the Soviet Union, Czechoslovakia, and both Underground and Communist Poland.',
        wiki: 'https://en.wikipedia.org/wiki/Ukrainian_Insurgent_Army',
    }, {
        name: 'Italian Civil War',
        started: 1943,
        ended: 1945,
        casualties: 162261,
        locations: ['Italy'],
        description: 'The Italian Civil War (Italian: La guerra civile) is the period between September 8, 1943 (the date of the armistice of Cassibile), and May 2, 1945 (the date of the surrender of German forces in Italy) in which the Italian Resistance and the Italian Co-Belligerent Army joined the allies fighting Axis forces including continuing Italian Fascists Italian Social Republic.',
        wiki: 'https://en.wikipedia.org/wiki/Italian_Civil_War',
    }, {
        name: 'Anti-communist resistance in Poland',
        started: 1944,
        ended: 1953,
        casualties: 31668,
        locations: ['Poland'],
        description: 'The anti-communist resistance in Poland (1944–1953), also referred to as the Polish anti-Communist insurrection, was an armed struggle by the Polish Underground against the Soviet takeover of Poland at the end of World War II in Europe.',
        wiki: 'https://en.wikipedia.org/wiki/Anti-communist_resistance_in_Poland_(1944%E2%80%9346)',
    }, {
        name: 'Iran crisis of 1946',
        started: 1945,
        ended: 1946,
        casualties: 2000,
        locations: ['Iran'],
        description: "The Iran crisis of 1946, also known as the Iran-Azerbaijan Crisis, followed the end of World War II and stemmed from the Soviet Union's refusal to relinquish occupied Iranian territory, despite repeated assurances.",
        wiki: 'https://en.wikipedia.org/wiki/Iran_crisis_of_1946',
    }, {
        name: 'Greek Civil War',
        started: 1946,
        ended: 1949,
        casualties: 158000,
        locations: ['Greece'],
        description: 'The Greek Civil War (Greek: ο Eμφύλιος [Πόλεμος], o Emfýlios [Pólemos], "the Civil War") was fought in Greece from 1946 to 1949 between the Greek government army (backed by the United Kingdom and the United States), and the Democratic Army of Greece (DSE, the military branch of the Greek Communist Party (KKE), backed by Yugoslavia and Albania as well as by Bulgaria), most probably the first proxy war of the Cold War. ',
        wiki: 'https://en.wikipedia.org/wiki/Greek_Civil_War',
    }, {
        name: 'Paraguayan Civil War',
        started: 1947,
        ended: 1947,
        casualties: null,
        locations: ['Paraguay'],
        description: 'The Paraguayan Civil War, also known as the Barefoot Revolution and the Second Paraguayan Civil War, was a conflict in Paraguay that lasted from March to August 1947.',
        wiki: 'https://en.wikipedia.org/wiki/Paraguayan_Civil_War_(1947)',
    }, {
        name: 'Romanian anti-communist resistance movement',
        started: 1947,
        ended: 1962,
        casualties: 2000,
        locations: ['Romania'],
        description: 'The Romanian anti-communist resistance movement was active from the late 1940s to the mid-1950s, with isolated individual fighters remaining at large until the early 1960s.',
        wiki: 'https://en.wikipedia.org/wiki/Romanian_anti-communist_resistance_movement',
    }, {
        name: '1947–48 Civil War in Mandatory Palestine',
        started: 1947,
        ended: 1948,
        casualties: 3116,
        locations: ['Palestine'],
        description: 'The 1947–48 Civil War in Mandatory Palestine was the first phase of the 1948 Palestine war. It broke out after the General Assembly of the United Nations adopted a resolution on 29 November 1947 recommending the adoption of the Partition Plan for Palestine.',
        wiki: 'https://en.wikipedia.org/wiki/1947%E2%80%9348_Civil_War_in_Mandatory_Palestine',
    }, {
        name: 'Costa Rican Civil War',
        started: 1948,
        ended: 1948,
        casualties: 2000,
        locations: ['Costa Rica'],
        description: 'The conflict was precipitated by the vote of the Costa Rican Legislature, dominated by pro-government representatives, to annul the results of the presidential elections held in February, alleging that the triumph of opposition candidate Otilio Ulate had been achieved by fraud.',
        wiki: 'https://en.wikipedia.org/wiki/Costa_Rican_Civil_War',
    }, {
        name: 'Yeosu-Suncheon rebellion',
        started: 1948,
        ended: 1948,
        casualties: 2000,
        locations: ['South Korea'],
        description: "The Yeosu–Suncheon rebellion, also known as the Yeo-Sun incident, was an October 1948 rebellion that took place in Yeosu, Suncheon, and surrounding towns, South Jeolla against the fledgling South Korean Syngman Rhee government largely cued by that government's suppression of the Jeju Uprising and refusal of Yeosu soldiers to help suppress the rebellion.",
        wiki: 'https://en.wikipedia.org/wiki/Yeosu%E2%80%93Suncheon_rebellion',
    }, {
        name: 'Jeju uprising',
        started: 1948,
        ended: 1949,
        casualties: 30000,
        locations: ['South Korea'],
        description: 'The Jeju uprising or Jeju massacre was an attempted insurgency on the Korean province of Jeju Island which was followed by an anticommunist suppression campaign that lasted from April 3, 1948 until May 1949.',
        wiki: 'https://en.wikipedia.org/wiki/Jeju_uprising',
    }, {
        name: 'La Violencia',
        started: 1948,
        ended: 1958,
        casualties: 194700,
        locations: ['Colombia'],
        description: 'La Violencia (Spanish pronunciation: [la βjoˈlensja], The Violence) was a ten-year civil war in Colombia from 1948 to 1958, between the Colombian Conservative Party and the Colombian Liberal Party, fought mainly in the countryside.',
        wiki: 'https://en.wikipedia.org/wiki/La_Violencia',
    }, {
        name: 'Malayan Emergency',
        started: 1948,
        ended: 1960,
        casualties: 10534,
        locations: ['Malaysia'],
        description: 'The Malayan Emergency (Malay: Darurat Malaya) was a guerrilla war fought in pre- and post-independence Federation of Malaya, from 1948 until 1960.',
        wiki: 'https://en.wikipedia.org/wiki/Malayan_Emergency',
    }, {
        name: 'Internal conflict in Myanmar',
        started: 1948,
        ended: null,
        casualties: 250000,
        locations: ['Myanmar'],
        description: "The internal conflict in Myanmar refers to a series of ongoing insurgencies within Myanmar that began shortly after the country, then known as Burma, became independent from the United Kingdom in 1948. The conflict has been labeled as the world's longest running civil war.",
        wiki: 'https://en.wikipedia.org/wiki/Internal_conflict_in_Myanmar',
    }, {
        name: 'Korean War',
        started: 1950,
        ended: 1953,
        casualties: 3428405,
        locations: ['North Korea', 'South Korea'],
        description: "The Korean War was a war between North Korea (with the support of China and the Soviet Union) and South Korea (with the principal support of the United States).",
        wiki: 'https://en.wikipedia.org/wiki/Korean_War',
    }, {
        name: 'Laotian Civil War',
        started: 1953,
        ended: 1975,
        casualties: 200000,
        locations: ['Laos'],
        description: "The Laotian Civil War (1953–75) was fought between the Communist Pathet Lao (including many North Vietnamese of Lao ancestry) and the Royal Lao Government, with both sides receiving heavy external support in a proxy war between the global Cold War superpowers.",
        wiki: 'https://en.wikipedia.org/wiki/Laotian_Civil_War',
    }, {
        name: 'First Sudanese Civil War',
        started: 1955,
        ended: 1972,
        casualties: 500000,
        locations: ['South Sudan'],
        description: "The First Sudanese Civil War (also known as the Anyanya Rebellion or Anyanya I, after the name of the rebels, a term in the Madi language which means 'snake venom') was a conflict from 1955 to 1972 between the northern part of Sudan and the southern Sudan region that demanded representation and more regional autonomy.",
        wiki: 'https://en.wikipedia.org/wiki/First_Sudanese_Civil_War',
    }, {
        name: 'Congo Crisis',
        started: 1960,
        ended: 1965,
        casualties: 100000,
        locations: ['Congo, Democratic Republic'],
        description: "The Congo Crisis (French: Crise congolaise) was a period of political upheaval and conflict in the Republic of the Congo (today the Democratic Republic of the Congo) between 1960 and 1965.",
        wiki: 'https://en.wikipedia.org/wiki/Congo_Crisis',
    }, {
        name: 'Guatemalan Civil War',
        started: 1960,
        ended: 1996,
        casualties: 200000,
        locations: ['Guatemala'],
        description: "The Guatemalan Civil War was fought between the government of Guatemala and various leftist rebel groups supported chiefly by ethnic Maya indigenous people and Ladino peasants, who together make up the rural poor.",
        wiki: 'https://en.wikipedia.org/wiki/Guatemalan_Civil_War',
    }, {
        name: 'North Yemen Civil War',
        started: 1962,
        ended: 1970,
        casualties: 200000,
        locations: ['Yemen'],
        description: "The North Yemen Civil War was fought in North Yemen from 1962 to 1970 between royalist partisans of the Mutawakkilite Kingdom and supporters of the Yemen Arab Republic.",
        wiki: 'https://en.wikipedia.org/wiki/North_Yemen_Civil_War',
    }, {
        name: 'Communist insurgency in Sarawak',
        started: 1962,
        ended: 1990,
        casualties: 2618,
        locations: ['Malaysia'],
        description: "The Communist insurgency in Sarawak involved the North Kalimantan Communist Party and the Malaysian Government. It was one of the two Communist insurgencies to challenge the former British colony of Malaysia during the Cold War.",
        wiki: 'https://en.wikipedia.org/wiki/Communist_insurgency_in_Sarawak',
    }, {
        name: 'Nicaraguan Revolution',
        started: 1962,
        ended: 1990,
        casualties: 40000,
        locations: ['Nicaragua'],
        description: "The Nicaraguan Revolution encompassed the rising opposition to the Somoza dictatorship in the 1960s and 1970s, the campaign led by the Sandinista National Liberation Front (FSLN) to violently oust the dictatorship in 1978–79, the subsequent efforts of the FSLN to govern Nicaragua from 1979 until 1990 and the Contra War which was waged between the FSLN and the Contras from 1981-1990.",
        wiki: 'https://en.wikipedia.org/wiki/Nicaraguan_Revolution',
    }, {
        name: 'Dominican Civil War',
        started: 1965,
        ended: 1965,
        casualties: 4294,
        locations: ['Dominican Republic'],
        description: "The Dominican Civil War took place in Santo Domingo, Dominican Republic. It started when civilian and military supporters of former President Juan Bosch overthrew acting President Donald Reid Cabral.",
        wiki: 'https://en.wikipedia.org/wiki/Dominican_Civil_War',
    }, {
        name: 'Rhodesian Bush War',
        started: 1964,
        ended: 1979,
        casualties: 19619,
        locations: ['Zimbabwe', 'Zambia', 'Mozambique'],
        description: " The conflict pitted three forces against one another: the Rhodesian government, led by Ian Smith (later the Zimbabwe-Rhodesian government of Bishop Abel Muzorewa); the Zimbabwe African National Liberation Army, the military wing of Robert Mugabe's Zimbabwe African National Union; and the Zimbabwe People's Revolutionary Army of Joshua Nkomo's Zimbabwe African People's Union.",
        wiki: 'https://en.wikipedia.org/wiki/Rhodesian_Bush_War',
    }, {
        name: 'Communist insurgency in Thailand',
        started: 1965,
        ended: 1983,
        casualties: 1815,
        locations: ['Thailand'],
        description: "The Communist insurgency in Thailand was a guerrilla war lasting from 1965 until 1983, fought mainly by the Communist Party of Thailand (CPT) and the government of Thailand. The war declined in 1980 following the declaration of an amnesty and by 1983 the CPT had abandoned the insurgency.",
        wiki: 'https://en.wikipedia.org/wiki/Communist_insurgency_in_Thailand',
    }, {
        name: 'Cyprus crisis',
        started: 1955,
        ended: 1964,
        casualties: 647,
        locations: ['Cyprus'],
        description: "There was a period of political and violent conflict in Cyprus, also known as the Cyprus crisis and EOKA period, between the Greek Cypriots and Turkish Cypriots, between 1955 and 1964.",
        wiki: 'https://en.wikipedia.org/wiki/Cyprus_crisis_(1955%E2%80%9364)',
    }, {
        name: 'Nigerian Civil War',
        started: 1967,
        ended: 1970,
        casualties: 100000,
        locations: ['Nigeria'],
        description: "The Nigerian Civil War, commonly known as the Biafran War, was a war fought between the government of Nigeria and the secessionist state of Biafra. Biafra represented nationalist aspirations of the Igbo people, whose leadership felt they could no longer coexist with the Northern-dominated federal government.",
        wiki: 'https://en.wikipedia.org/wiki/Nigerian_Civil_War',
    }, {
        name: 'Communist insurgency in Malaysia',
        started: 1968,
        ended: 1989,
        casualties: 367,
        locations: ['Malaysia'],
        description: "The Communist insurgency in Malaysia, also known as the Second Malayan Emergency, was an armed conflict which occurred in Malaysia from 1968 to 1989, involving the Malayan Communist Party (MCP) and Malaysian federal security forces.",
        wiki: 'https://en.wikipedia.org/wiki/Communist_insurgency_in_Malaysia_(1968%E2%80%9389)',
    }, {
        name: 'The Troubles',
        started: 1968,
        ended: 1998,
        casualties: 3532,
        locations: ['Ireland'],
        description: "The Troubles was an ethno-nationalist conflict in Northern Ireland during the late 20th century. Also known internationally as the Northern Ireland conflict, it is sometimes described as a 'guerrilla war' or a 'low-level war'.",
        wiki: 'https://en.wikipedia.org/wiki/The_Troubles',
    }, {
        name: 'Cambodian Civil War',
        started: 1967,
        ended: 1975,
        casualties: 300000,
        locations: ['Cambodia'],
        description: "The Cambodian Civil War was a military conflict that pitted the forces of the Communist Party of Kampuchea and their allies the Democratic Republic of Vietnam (North Vietnam) and the Viet Cong against the government forces of the Kingdom of Cambodia and, after October 1970, the Khmer Republic, which were supported by the United States (U.S.) and the Republic of Vietnam (South Vietnam).",
        wiki: 'https://en.wikipedia.org/wiki/Cambodian_Civil_War',
    }, {
        name: 'Bangladesh Liberation War',
        started: 1971,
        ended: 1971,
        casualties: 339525,
        locations: ['Bangladesh'],
        description: "The Bangladesh Liberation War, also known as the Bangladesh War of Independence, or simply the Liberation War in Bangladesh, was a revolution and armed conflict sparked by the rise of the Bengali nationalist and self-determination movement in what was then East Pakistan and the 1971 Bangladesh genocide.",
        wiki: 'https://en.wikipedia.org/wiki/Bangladesh_Liberation_War',
    }, {
        name: 'Ethiopian Civil War',
        started: 1974,
        ended: 1991,
        casualties: 1579000,
        locations: ['Ethiopia'],
        description: "The Ethiopian Civil War began on 12 September 1974 when the Marxist-Leninist Derg staged a coup d'état against Emperor Haile Selassie. The civil war lasted until the Ethiopian People's Revolutionary Democratic Front (EPRDF), a coalition of rebel groups, overthrew the government in 1991.",
        wiki: 'https://en.wikipedia.org/wiki/Ethiopian_Civil_War',
    }, {
        name: 'Lebanese Civil War',
        started: 1975,
        ended: 1990,
        casualties: 150000,
        locations: ['Lebanon'],
        description: "The Lebanese Civil War (Arabic: الحرب الأهلية اللبنانية‎‎ – Al-Ḥarb al-Ahliyyah al-Libnāniyyah) was a multifaceted civil war in Lebanon, lasting from 1975 to 1990 and resulting in an estimated 120,000 fatalities.",
        wiki: 'https://en.wikipedia.org/wiki/Lebanese_Civil_War',
    }, {
        name: 'Mozambican Civil War',
        started: 1977,
        ended: 1992,
        casualties: 1000000,
        locations: ['Mozambique'],
        description: "The Mozambican Civil War began in 1977, two years after the end of the war of independence. It resembled the Angolan Civil War in that both were proxy wars of the Cold War that started soon after the countries gained independence from Portugal.",
        wiki: 'https://en.wikipedia.org/wiki/Mozambican_Civil_War',
    }, {
        name: 'Angolan Civil War',
        started: 1975,
        ended: 2002,
        casualties: 522092,
        locations: ['Angola'],
        description: "The Angolan Civil War (Portuguese: Guerra civil angolana) was a major civil conflict in Angola, beginning in 1975 and continuing, with some interludes, until 2002. The war began immediately after Angola became independent from Portugal in November 1975.",
        wiki: 'https://en.wikipedia.org/wiki/Angolan_Civil_War',
    }, {
        name: 'Free Aceh Movement',
        started: 1976,
        ended: 2005,
        casualties: 14464,
        locations: ['Indonesia'],
        description: "The Free Aceh Movement was a separatist group seeking independence for the Aceh region of Sumatra from Indonesia. ",
        wiki: 'https://en.wikipedia.org/wiki/Free_Aceh_Movement',
    }, {
        name: 'Soviet-Afghan War',
        started: 1979,
        ended: 1989,
        casualties: 2104753,
        locations: ['Afghanistan'],
        description: "The Soviet–Afghan War lasted over nine years, from December 1979 to February 1989. Insurgent groups known as the mujahideen fought against the Soviet Army and the Democratic Republic of Afghanistan government, mostly in the country's rural countryside.",
        wiki: 'https://en.wikipedia.org/wiki/Soviet%E2%80%93Afghan_War',
    }, {
        name: 'Salvadoran Civil War',
        started: 1979,
        ended: 1992,
        casualties: 107000,
        locations: ['El Salvador'],
        description: "The Salvadoran Civil War was a conflict between the military-led government of El Salvador and the Farabundo Martí National Liberation Front (FMLN), a coalition or 'umbrella organization' of five left-wing guerrilla groups.",
        wiki: 'https://en.wikipedia.org/wiki/Salvadoran_Civil_War',
    }, {
        name: 'Second Sudanese Civil War',
        started: 1983,
        ended: 2005,
        casualties: 2000000,
        locations: ['South Sudan'],
        description: "The Second Sudanese Civil War was a conflict from 1983 to 2005 between the central Sudanese government and the Sudan People's Liberation Army. It was largely a continuation of the First Sudanese Civil War of 1955 to 1972.",
        wiki: 'https://en.wikipedia.org/wiki/Second_Sudanese_Civil_War',
    }, {
        name: 'Sri Lankan Civil War',
        started: 1983,
        ended: 2009,
        casualties: 151527,
        locations: ['Sri Lanka'],
        description: "The Sri Lankan Civil War was an armed conflict fought on the island of Sri Lanka. There was an intermittent insurgency against the government by the Liberation Tigers of Tamil Eelam (the LTTE, also known as the Tamil Tigers), which fought to create an independent Tamil state called Tamil Eelam in the north and the east of the island.",
        wiki: 'https://en.wikipedia.org/wiki/Sri_Lankan_Civil_War',
    }, {
        name: 'South Yemen Civil War',
        started: 1986,
        ended: 1986,
        casualties: 10000,
        locations: ['Yemen'],
        description: "The South Yemen Civil War, colloquially referred to as The Events of '86, or more simply as The Events, was a failed coup d'etat and armed conflict which took place in January 1986 in South Yemen.",
        wiki: 'https://en.wikipedia.org/wiki/South_Yemen_Civil_War',
    }, {
        name: 'Afghan Civil War',
        started: 1989,
        ended: 1992,
        casualties: 23000,
        locations: ['Afghanistan'],
        description: "The 1989 to 1992 phase of the Afghan Civil War began after the Soviet Union withdrew from Afghanistan, leaving the Afghan communist government to fend for itself against the Mujahideen.",
        wiki: 'https://en.wikipedia.org/wiki/Afghan_Civil_War_(1989%E2%80%9392)',
    }, {
        name: 'War in Afghanistan',
        started: 1978,
        ended: null,
        casualties: 2084468,
        locations: ['Afghanistan'],
        description: "The War in Afghanistan began on 27 April 1978, when the People's Democratic Party of Afghanistan (PDPA) took power in a military coup, known as the Saur Revolution. Most of Afghanistan subsequently experienced uprisings against the PDPA government.",
        wiki: 'https://en.wikipedia.org/wiki/War_in_Afghanistan_(1978%E2%80%93present)',
    }, {
        name: 'First Liberian Civil War',
        started: 1989,
        ended: 1997,
        casualties: 620000,
        locations: ['Liberia'],
        description: "The First Liberian Civil War was an internal conflict in Liberia from 1989 until 1997. The conflict killed about 250,000 people and eventually led to the involvement of the Economic Community of West African States (ECOWAS) and of the United Nations.",
        wiki: 'https://en.wikipedia.org/wiki/First_Liberian_Civil_War',
    }, {
        name: 'Rwandan Civil War',
        started: 1990,
        ended: 1994,
        casualties: 1010000,
        locations: ['Rwanda'],
        description: "The Rwandan Civil War was a conflict in the African republic of Rwanda, between the Rwandan Armed Forces (FAR) and the rebel Rwandan Patriotic Front (RPF). The outbreak of the Rwandan genocide corresponds to the end of this Civil War",
        wiki: 'https://en.wikipedia.org/wiki/Rwandan_Civil_War',
    }, {
        name: 'Casamance conflict',
        started: 1982,
        ended: null,
        casualties: 5000,
        locations: ['Senegal'],
        description: "The Casamance conflict is an ongoing low-level conflict that has been waged between the Government of Senegal and the Movement of Democratic Forces of Casamance (MFDC) since 1982.",
        wiki: 'https://en.wikipedia.org/wiki/Casamance_conflict',
    }, {
        name: 'Georgian Civil War',
        started: 1991,
        ended: 1993,
        casualties: 20000,
        locations: ['Georgia'],
        description: "The Georgian Civil War comprised inter-ethnic and intranational conflicts in the regions of South Ossetia (1988–1992) and Abkhazia (1992–1993), as well as the violent military coup d'état (1991-1993), against the first democratically elected President of Georgia, Zviad Gamsakhurdia and his subsequent uprising in an attempt to regain power (1993).",
        wiki: 'https://en.wikipedia.org/wiki/Georgian_Civil_War',
    }, {
        name: 'Sierra Leone Civil War',
        started: 1991,
        ended: 2002,
        casualties: 300000,
        locations: ['Sierra Leone'],
        description: "The Sierra Leone Civil War (1991–2002) began on 23 March 1991 when the Revolutionary United Front (RUF), with support from the special forces of Charles Taylor’s National Patriotic Front of Liberia (NPFL), intervened in Sierra Leone in an attempt to overthrow the Joseph Momoh government.",
        wiki: 'https://en.wikipedia.org/wiki/Sierra_Leone_Civil_War',
    }, {
        name: 'Algerian Civil War',
        started: 1991,
        ended: 2002,
        casualties: 150000,
        locations: ['Algeria'],
        description: "The Algerian Civil War was an armed conflict between the Algerian Government and various Islamic rebel groups which began in 1991 following a coup negating an Islamist electoral victory.",
        wiki: 'https://en.wikipedia.org/wiki/Algerian_Civil_War',
    }, {
        name: 'Tajikistani Civil War',
        started: 1992,
        ended: 1997,
        casualties: 60000,
        locations: ['Tajikistan'],
        description: "The Tajikistani Civil War began in May 1992 when ethnic groups from the Garm and Gorno-Badakhshan regions of Tajikistan rose up against the government of President Rahmon Nabiyev, which was dominated by people from the Khujand and Kulyab regions.",
        wiki: 'https://en.wikipedia.org/wiki/Tajikistani_Civil_War',
    }, {
        name: 'Afghan Civil War',
        started: 1992,
        ended: 1996,
        casualties: 100,
        locations: ['Afghanistan'],
        description: "The 1992 to 1996 phase of the conflict in Afghanistan (1978–present) began after the resignation of the communist President Mohammad Najibullah.",
        wiki: 'https://en.wikipedia.org/wiki/Afghan_Civil_War_(1992%E2%80%9396)',
    }, {
        name: 'Burundian Civil War',
        started: 1993,
        ended: 2006,
        casualties: 300000,
        locations: ['Burundi'],
        description: "The Burundian Civil War was an armed conflict lasting from 1993 to 2006. The civil war was the result of long standing ethnic divisions between the Hutu and the Tutsi ethnic groups in Burundi.",
        wiki: 'https://en.wikipedia.org/wiki/Burundian_Civil_War',
    }, {
        name: 'Yemeni Civil War',
        started: 1994,
        ended: 1994,
        casualties: 10000,
        locations: ['Yemen'],
        description: "The May–July 1994 civil war in Yemen was a civil conflict waged between the two Yemeni forces of the pro-union northern and the socialist separatist southern Yemeni states and their supporters. The war resulted in the defeat of the southern armed forces, the reunification of Yemen, and the flight into exile of many Yemeni Socialist Party (YSP) leaders and other separatists.",
        wiki: 'https://en.wikipedia.org/wiki/Yemeni_Civil_War_(1994)',
    }, {
        name: 'First Chechen War',
        started: 1994,
        ended: 1996,
        casualties: 111391,
        locations: ['Russia'],
        description: "The First Chechen War, also known War in Chechnya, was a conflict between the Russian Federation and the Chechen Republic of Ichkeria, fought from December 1994 to August 1996.",
        wiki: 'https://en.wikipedia.org/wiki/First_Chechen_War',
    }, {
        name: 'Iraqi-Kurdish Civil War',
        started: 1994,
        ended: 1997,
        casualties: 5000,
        locations: ['Iraq'],
        description: "The Iraqi Kurdish Civil War was a military conflict that took place between rival Kurdish factions in Iraqi Kurdistan during the mid-1990s, most notably between the Patriotic Union of Kurdistan and the Kurdistan Democratic Party.",
        wiki: 'https://en.wikipedia.org/wiki/Iraqi%E2%80%93Kurdish_Civil_War',
    }, {
        name: 'Afghan Civil War',
        started: 1996,
        ended: 2001,
        casualties: 3000,
        locations: ['Afghanistan'],
        description: "The Afghan Civil War fought between 1996 and 2001 was part of the wider War in Afghanistan ongoing since 1978. In 1996 the Taliban captured the Afghan capital Kabul and established the Islamic Emirate of Afghanistan.",
        wiki: 'https://en.wikipedia.org/wiki/Afghan_Civil_War_(1996%E2%80%932001)',
    }, {
        name: 'First Congo War',
        started: 1996,
        ended: 1997,
        casualties: 800000,
        locations: ['Congo, Democratic Republic'],
        description: "The First Congo War (1996–1997) was a foreign invasion of Zaire led by Rwanda that replaced President Mobutu Sésé Seko with the rebel leader Laurent-Désiré Kabila. Destabilization in eastern Zaire resulting from the Rwandan Genocide was the final factor that caused numerous internal and external factors to align against the corrupt and inept government in the capital, Kinshasa.",
        wiki: 'https://en.wikipedia.org/wiki/First_Congo_War',
    }, {
        name: '1997 Clashes in Cambodia',
        started: 1997,
        ended: 1997,
        casualties: 140,
        locations: ['Cambodia'],
        description: "The 1997 clashes in Cambodia, also referred to as the 1997 coup in Cambodia (especially by critics of Hun Sen), took place in Cambodia in July and August 1997. As a result, co-premier Hun Sen ousted the other co-premier Norodom Ranariddh. Dozens of people were killed during the conflict.",
        wiki: 'https://en.wikipedia.org/wiki/1997_clashes_in_Cambodia',
    }, {
        name: 'Nepalese Civil War',
        started: 1996,
        ended: 2006,
        casualties: 17800,
        locations: ['Nepal'],
        description: "The Nepalese Civil War was an armed conflict between the Communist Party of Nepal (Maoist) (CPN-M) and the government of Nepal, fought from 1996 to 2006.",
        wiki: 'https://en.wikipedia.org/wiki/Nepalese_Civil_War',
    }, {
        name: 'Albanian Civil War',
        started: 1997,
        ended: 1997,
        casualties: 3800,
        locations: ['Albania'],
        description: "The Albanian Civil War, also known as the Albanian rebellion, Albanian unrest or the Pyramid crisis, was a period of civil disorder in Albania in 1997, sparked by Ponzi scheme failures.",
        wiki: 'https://en.wikipedia.org/wiki/Albanian_Civil_War',
    }, {
        name: 'Republic of the Congo Civil War',
        started: 1997,
        ended: 1999,
        casualties: 20050,
        locations: ['Congo, Democratic Republic'],
        description: "The Second Republic of the Congo Civil War was an ethnopolitical civil conflict in the African state of Republic of the Congo, beginning on 5 June 1997 and continuing until December 1999.",
        wiki: 'https://en.wikipedia.org/wiki/Republic_of_the_Congo_Civil_War_(1997%E2%80%9399)',
    }, {
        name: 'Guinea-Bissau Civil War',
        started: 1998,
        ended: 1999,
        casualties: 655,
        locations: ['Guinea-Bissau'],
        description: "The Guinea-Bissau Civil War was fought from 7 June 1998 to 10 May 1999 and was triggered by an attempted coup d'état against the government of President João Bernardo Vieira led by Brigadier-General Ansumane Mané.",
        wiki: 'https://en.wikipedia.org/wiki/Guinea-Bissau_Civil_War',
    }, {
        name: 'Kosovo War',
        started: 1998,
        ended: 1999,
        casualties: 17588,
        locations: ['Albania'],
        description: "The Kosovo War was fought by the forces of the Federal Republic of Yugoslavia, which controlled Kosovo before the war, and the Kosovo Albanian rebel group known as the Kosovo Liberation Army (KLA), with air support NATO, and ground support from the Albanian army.",
        wiki: 'https://en.wikipedia.org/wiki/Kosovo_War',
    }, {
        name: 'Second Congo War',
        started: 1998,
        ended: 2003,
        casualties: 5756000,
        locations: ['Congo, Democratic Republic'],
        description: "The Second Congo War began in August 1998 in the Democratic Republic of the Congo, little more than a year after the First Congo War, and involved some of the same issues.",
        wiki: 'https://en.wikipedia.org/wiki/Second_Congo_War',
    }, {
        name: '1999 Shia uprising in Iraq',
        started: 1999,
        ended: 1999,
        casualties: 340,
        locations: ['Iraq'],
        description: "The 1999 Shia uprising in Iraq refers to a short period of unrest in Iraq in early 1999 following the killing of Mohammad Mohammad Sadeq al-Sadr by the then Ba'athist government of Iraq.",
        wiki: 'https://en.wikipedia.org/wiki/1999_Shia_uprising_in_Iraq',
    }, {
        name: 'Second Liberian Civil War',
        started: 1999,
        ended: 2003,
        casualties: 300000,
        locations: ['Liberia'],
        description: "The Second Liberian Civil War began in 1999 when a rebel group backed by the government of neighbouring Guinea, the Liberians United for Reconciliation and Democracy (LURD), emerged in northern Liberia.",
        wiki: 'https://en.wikipedia.org/wiki/Second_Liberian_Civil_War',
    }, {
        name: 'Second Chechen War',
        started: 1999,
        ended: 2009,
        casualties: 250000,
        locations: ['Russia'],
        description: "The Second Chechen War was an invasion launched by the Russian Federation, starting 26 August 1999, in response to the Invasion of Dagestan by the Islamic International Brigade (IIB).",
        wiki: 'https://en.wikipedia.org/wiki/Second_Chechen_War',
    }, {
        name: '2001 insurgency in the Republic of Macedonia',
        started: 2001,
        ended: 2001,
        casualties: 250,
        locations: ['Macedonia'],
        description: "The 2001 insurgency in the Republic of Macedonia was an armed conflict which began when the ethnic Albanian National Liberation Army (NLA) militant group attacked the security forces of the Republic of Macedonia at the beginning of February 2001, and ended with the Ohrid Agreement.",
        wiki: 'https://en.wikipedia.org/wiki/2001_insurgency_in_the_Republic_of_Macedonia',
    }, {
        name: 'First Ivorian Civil War',
        started: 2002,
        ended: 2007,
        casualties: 1816,
        locations: ['Ivory Coast'],
        description: "The First Ivorian Civil War was a conflict in the Ivory Coast (also known as Côte d'Ivoire) that began in 2002. Although most of the fighting ended by late 2004, the country remained split in two, with a rebel-held Muslim north and a government-held Christian south.",
        wiki: 'https://en.wikipedia.org/wiki/First_Ivorian_Civil_War',
    }, {
        name: 'Houthi insurgency in Yemen',
        started: 2004,
        ended: 2015,
        casualties: 25000,
        locations: ['Yemen'],
        description: "The Houthi insurgency in Yemen was a sectarian military rebellion pitting Zaidi Shia Houthis (though the movement also includes Sunnis) against the Yemeni military that began in Northern Yemen and has since escalated into a full-scale civil war.",
        wiki: 'https://en.wikipedia.org/wiki/Houthi_insurgency_in_Yemen',
    }, {
        name: 'Chadian Civil War',
        started: 2005,
        ended: 2010,
        casualties: 7000,
        locations: ['Chad'],
        description: "The most recent Chadian Civil War[32] began in December 2005. Since its independence from France in 1960, Chad has been swamped by the civil war between the Arab-Muslims of the north and the Sub-Saharan-Christians of the south.",
        wiki: 'https://en.wikipedia.org/wiki/Chadian_Civil_War_(2005%E2%80%932010)',
    }, {
        name: 'Sectarian violence in Iraq',
        started: 2006,
        ended: 2008,
        casualties: 10000,
        locations: ['Iraq'],
        description: "Between 2006 and 2008, Iraq experienced a high level of sectarian violence. Some scholars and journalists state that the country was experiencing a civil war.",
        wiki: 'https://en.wikipedia.org/wiki/Sectarian_violence_in_Iraq_(2006%E2%80%9308)',
    }, {
        name: 'Fatah-Hamas conflict',
        started: 2006,
        ended: null,
        casualties: 600,
        locations: ['Palestinian Territory, Occupied', 'Gaza Strip'],
        description: "The Fatah–Hamas conflict (Arabic: النزاع بين فتح وحماس‎ an-Nizāʿ bayna Fataḥ wa-Ḥamās), also referred to as the Palestinian Civil War (Arabic: الحرب الأهلية الفلسطينية‎ al-Ḥarb al-ʾAhliyyah al-Filisṭīnīyyah), was a conflict between the two main Palestinian political parties, Fatah and Hamas, resulting in the split of the Palestinian Authority in 2007.",
        wiki: 'https://en.wikipedia.org/wiki/Fatah%E2%80%93Hamas_conflict',
    }, {
        name: 'South Yemen insurgency',
        started: 2009,
        ended: 2015,
        casualties: 2054,
        locations: ['Yemen'],
        description: "The South Yemen insurgency is a term used by the Yemeni government to describe the protests and attacks on government forces in southern Yemen, ongoing since 27 April 2009, on South Yemen's independence day.",
        wiki: 'https://en.wikipedia.org/wiki/South_Yemen_insurgency',
    }, {
        name: 'Second Ivorian Civil War',
        started: 2010,
        ended: 2011,
        casualties: 3000,
        locations: ['Ivory Coast'],
        description: "The Second Ivorian Civil War broke out in March 2011 when the crisis in Ivory Coast escalated into full-scale military conflict between forces loyal to Laurent Gbagbo, the President of Ivory Coast since 2000, and supporters of the internationally recognised president-elect Alassane Ouattara.",
        wiki: 'https://en.wikipedia.org/wiki/Second_Ivorian_Civil_War',
    }, {
        name: 'Tajikistan insurgency',
        started: 2010,
        ended: 2012,
        casualties: 159,
        locations: ['Tajikistan'],
        description: "The Tajikistan Insurgency was a military conflict which took place in eastern Tajikistan between the Tajik army and Islamist militants, led by numerous leaders from the Tajikistani Civil War.",
        wiki: 'https://en.wikipedia.org/wiki/Tajikistan_insurgency',
    }, {
        name: 'Myanmar border clashes',
        started: 2010,
        ended: 2012,
        casualties: 46,
        locations: ['Myanmar'],
        description: "The 2010–2012 Myanmar border clashes were a series of skirmishes between the Tatmadaw (Myanmar Armed Forces) and the DKBA-5.",
        wiki: 'https://en.wikipedia.org/wiki/2010%E2%80%9312_Myanmar_border_clashes',
    }, {
        name: 'Libyan Civil War',
        started: 2011,
        ended: 2011,
        casualties: 20000,
        locations: ['Libya'],
        description: "The first Libyan Civil War, also referred to as the Libyan Revolution or 17 February Revolution, was an armed conflict in 2011, in the North African country of Libya, fought between forces loyal to Colonel Muammar Gaddafi and those seeking to oust his government.",
        wiki: 'https://en.wikipedia.org/wiki/Libyan_Civil_War_(2011)',
    }, {
        name: 'Factional violence in Libya',
        started: 2011,
        ended: 2014,
        casualties: 1329,
        locations: ['Libya'],
        description: "Since the end of the 2011 Libyan Civil War, which overthrew Muammar Gaddafi, there has been violence involving various militias and the new state security forces. The violence has escalated into the current 2014 Libyan Civil War.",
        wiki: 'https://en.wikipedia.org/wiki/Factional_violence_in_Libya_(2011%E2%80%9314)',
    }, {
        name: 'Iraqi insurgency',
        started: 2011,
        ended: 2013,
        casualties: 24625,
        locations: ['Iraq'],
        description: "The Iraqi insurgency, later referred to as the Iraq Crisis, escalated after the withdrawal of U.S. troops in 2011, resulting in violent conflict with the central government, as well as sectarian violence among Iraq's religious groups.",
        wiki: 'https://en.wikipedia.org/wiki/Iraqi_insurgency_(2011%E2%80%9313)',
    }, {
        name: 'Tuareg rebellion',
        started: 2012,
        ended: 2012,
        casualties: 1665,
        locations: ['Mali'],
        description: "The Tuareg Rebellion of 2012 was an early stage of the Northern Mali conflict; from January to April 2012, a war was waged against the Malian government by rebels with the goal of attaining independence for the northern region of Mali, known as Azawad.",
        wiki: 'https://en.wikipedia.org/wiki/Tuareg_rebellion_(2012)',
    }, {
        name: 'Northern Mali Conflict',
        started: 2012,
        ended: null,
        casualties: 2623,
        locations: ['Mali'],
        description: "The Northern Mali Conflict refers to armed conflicts that started from January 2012 between the northern and southern parts of Mali in Africa. On 16 January 2012, several insurgent groups began fighting a campaign against the Malian government for independence or greater autonomy for northern Mali, an area known as Azawad.",
        wiki: 'https://en.wikipedia.org/wiki/Northern_Mali_conflict',
    }, {
        name: 'M23 rebellion',
        started: 2012,
        ended: 2013,
        casualties: 1449,
        locations: ['Congo, Democratic Republic'],
        description: "The M23 rebellion was fighting in North Kivu, Democratic Republic of the Congo (DRC), that occurred between the March 23 Movement and government forces.",
        wiki: 'https://en.wikipedia.org/wiki/M23_rebellion',
    }, {
        name: 'Papua Conflict',
        started: 1962,
        ended: null,
        casualties: 804350,
        locations: ['Papua New Guinea', 'Indonesia'],
        description: "The Papua conflict is an ongoing conflict between the Indonesian government and portions of the indigenous populations of Western New Guinea (Papua) in the Indonesian provinces of Papua and West Papua on the island of New Guinea, in which the Indonesian government has been accused of conducting a genocidal campaign against the indigenous inhabitants.",
        wiki: 'https://en.wikipedia.org/wiki/Papua_conflict',
    }, {
        name: 'Colombian Conflict',
        started: 1964,
        ended: null,
        casualties: 218094,
        locations: ['Colombia'],
        description: "The Colombian conflict began in the mid-1960s and is a low-intensity asymmetric war between Colombian governments, paramilitary groups, crime syndicates, and left-wing guerrillas such as the Revolutionary Armed Forces of Colombia (FARC), and the National Liberation Army (ELN), fighting each other to increase their influence in Colombian territory.",
        wiki: 'https://en.wikipedia.org/wiki/Colombian_conflict',
    }, {
        name: 'Internal conflict in Peru',
        started: 1980,
        ended: null,
        casualties: 69280,
        locations: ['Peru'],
        description: "The internal conflict in Peru, beginning in 1980, is an ongoing armed conflict between the government of Peru and some terrorist organizations such as the insurgent People's Guerilla Army, armed wing of the Communist Party of Peru and the Tupac Amaru Revolutionary Movement which was also involved in the conflict from 1982 to 1997.",
        wiki: 'https://en.wikipedia.org/wiki/Internal_conflict_in_Peru',
    }, {
        name: 'Kurdish-Turkey conflict',
        started: 1978,
        ended: null,
        casualties: 55000,
        locations: ['Turkey', 'Iraq', 'Syria'],
        description: "The Kurdish–Turkish conflict is an armed conflict between the Republic of Turkey and various Kurdish insurgent groups, which have demanded separation from Turkey to create an independent Kurdistan, or to have autonomy and greater political and cultural rights for Kurds inside the Republic of Turkey.",
        wiki: 'https://en.wikipedia.org/wiki/Kurdish%E2%80%93Turkish_conflict_(1978%E2%80%93present)',
    }, {
        name: 'Somali Civil War',
        started: 1986,
        ended: null,
        casualties: 500000,
        locations: ['Somalia'],
        description: "The Somali Civil War is an ongoing civil war taking place in Somalia. It grew out of resistance to the military junta led by Siad Barre during the 1980s.",
        wiki: 'https://en.wikipedia.org/wiki/Somali_Civil_War',
    }, {
        name: 'War in Darfur',
        started: 2003,
        ended: null,
        casualties: 300000,
        locations: ['Sudan'],
        description: "The War in Darfur is a major armed conflict in the Darfur region of Sudan, that began in February 2003 when the Sudan Liberation Movement (SLM) and the Justice and Equality Movement (JEM) rebel groups began fighting the government of Sudan, which they accused of oppressing Darfur's non-Arab population.",
        wiki: 'https://en.wikipedia.org/wiki/War_in_Darfur',
    }, {
        name: 'War in North-West Pakistan',
        started: 2004,
        ended: null,
        casualties: 62400,
        locations: ['Pakistan'],
        description: "The War in North-West Pakistan, also known as the War in Waziristan, is an armed conflict involving Pakistan, and armed militant groups such as the Tehrik-i-Taliban Pakistan (TTP), Jundallah, Lashkar-e-Islam (LeI), TNSM, al-Qaeda, and their Central Asian allies such as the ISIL–Khorasan (ISIL), Islamic Movement of Uzbekistan, East Turkistan Movement, Emirate of Caucasus, and elements of organized crime",
        wiki: 'https://en.wikipedia.org/wiki/War_in_North-West_Pakistan',
    }, {
        name: 'Insurgency in Paraguay',
        started: 2005,
        ended: null,
        casualties: 72,
        locations: ['Paraguay'],
        description: "The Insurgency in Paraguay, also named the Paraguayan People’s Army insurgency and EPP rebellion (from the group's name in Spanish: Ejército del Pueblo Paraguayo), is an ongoing low-level armed conflict in northeastern Paraguay.",
        wiki: 'https://en.wikipedia.org/wiki/Insurgency_in_Paraguay',
    }, {
        name: 'Sudanese nomadic conflicts',
        started: 2008,
        ended: null,
        casualties: 2500,
        locations: ['Sudan', 'South Sudan'],
        description: "Sudanese nomadic conflicts are non-state conflicts between rival nomadic tribes taking place in the territory of Sudan and, since 2011, South Sudan.",
        wiki: 'https://en.wikipedia.org/wiki/Sudanese_nomadic_conflicts',
    }, {
        name: 'Syrian Civil War',
        started: 2011,
        ended: null,
        casualties: 475000,
        locations: ['Syria'],
        description: "The Syrian Civil War is an ongoing multi-sided armed conflict in Syria fought primarily between the government of President Bashar al-Assad, along with its allies, and various forces opposing the government.",
        wiki: 'https://en.wikipedia.org/wiki/Syrian_Civil_War',
    }, {
        name: 'Sudanese conflict in South kordofan and Blue Nile',
        started: 2011,
        ended: null,
        casualties: 1500,
        locations: ['Sudan'],
        description: "The Sudanese conflict in South Kordofan and Blue Nile, also referred to by some media as the Third Sudanese Civil War, is an ongoing armed conflict in the Sudanese southern states of South Kordofan and Blue Nile between the Army of Sudan (SAF) and Sudan People's Liberation Movement-North (SPLM-N), a northern affiliate of the Sudan People's Liberation Movement (SPLM) in South Sudan.",
        wiki: 'https://en.wikipedia.org/wiki/Sudanese_conflict_in_South_Kordofan_and_Blue_Nile',
    }, {
        name: 'Central African Republic Civil War',
        started: 2012,
        ended: 2014,
        casualties: 5186,
        locations: ['Central African Republic'],
        description: "The Central African Republic conflict was a civil war in the Central African Republic (CAR) involving the government, rebels from the Séléka coalition and the Anti-balaka militias.",
        wiki: 'https://en.wikipedia.org/wiki/Central_African_Republic_Civil_War_(2012%E2%80%932014)',
    }, {
        name: 'South Sudanese Civil War',
        started: 2013,
        ended: null,
        casualties: 300000,
        locations: ['South Sudan'],
        description: "The South Sudanese Civil War (sometimes known as the Third Sudanese Civil War) is a conflict in South Sudan between forces of the government and opposition forces.",
        wiki: 'https://en.wikipedia.org/wiki/South_Sudanese_Civil_War',
    }, {
        name: 'Iraqi Civil War',
        started: 2014,
        ended: null,
        casualties: 109829,
        locations: ['Iraq'],
        description: "The Iraqi Civil War is an ongoing armed conflict in the Middle East. In 2014, the Iraqi insurgency escalated into a civil war with the conquest of Fallujah, Mosul, Tikrit and major areas in northern Iraq by the Islamic State of Iraq and the Levant (ISIL, also known as ISIS or IS).",
        wiki: 'https://en.wikipedia.org/wiki/Iraqi_Civil_War_(2014%E2%80%93present)',
    }, {
        name: 'Libyan Civil War',
        started: 2014,
        ended: null,
        casualties: 9754,
        locations: ['Libya'],
        description: "The second Libyan Civil War is an ongoing conflict among rival groups seeking control of the territory of Libya.",
        wiki: 'https://en.wikipedia.org/wiki/Libyan_Civil_War_(2014%E2%80%93present)',
    }, {
        name: 'Yemeni Civil War',
        started: 2015,
        ended: null,
        casualties: 10000,
        locations: ['Yemen', 'Saudi Arabia'],
        description: "The Yemeni Civil War is an ongoing conflict that began in 2015 between two factions claiming to constitute the Yemeni government, along with their supporters and allies.",
        wiki: 'https://en.wikipedia.org/wiki/Yemeni_Civil_War_(2015%E2%80%93present)',
    },
]

export default civilwars;


// WEBPACK FOOTER //
// ./src/data/data_wars.js